<template>
<div class="pageCon-wrapper">
    <el-scrollbar class="pageCon-wrapper-scrollbar" v-if="scroll">
        <div class="pageCon-wrapper--breadcrumb" v-show="breadcrumb">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="item in breadcrumbList" :key="item.path" >{{item.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <slot />
    </el-scrollbar>
    <template v-else>
        <div class="pageCon-wrapper--breadcrumb" v-show="breadcrumb">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="item in breadcrumbList" :key="item.path" >{{item.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <slot />
    </template>
</div>
</template>
<script>
export default {
    props:{
        'scroll':{
            type:Boolean,
            default:true
        }
    },
    data(){
        return {
            breadcrumb:false
        }
    },
    computed:{
        breadcrumbList(){
            let matched = this.$route.matched
            return matched.filter(item => !!item.meta.title)
        }
    }
}
</script>
<style lang="scss">
.pageCon-wrapper {
    height: 100%;
    &--breadcrumb {
        height: 36px;
        background: #fff;
        box-shadow: 0 1px 0 0 rgba(219, 219, 219, 0.50);
        padding: 0px 20px;
        .el-breadcrumb {
            line-height: 36px;
            font-size: 12px;
            color: #474E64;
        }
        .el-breadcrumb__inner a,
        .el-breadcrumb__inner.is-link {
            font-weight: normal;
            color: #474E64;
        }
    }
    .pageCon-title{
        position: relative;
        background: #FFF;
        height:48px;
        line-height: 48px;
        // border-top:1px solid #DBDBDB;
        // border-bottom:1px solid #DBDBDB;
        font-weight:bold; 
        font-size: 16px;
        color: #464C5B;
        padding: 0px 20px;
        box-sizing: border-box;
        border-radius: 2px;
        i{
            display: inline-block;
            vertical-align: sub;
            width:5px;
            height:18px;
            margin-right: 10px;
            background: #00B38A;
        }
        .title-menu{
            position: absolute;
            right:20px;
            top:50%;
            transform: translateY(-53%);
            .el-button{
                width: 94px;
            }
            .el-button + .el-button{
                margin-left: 15px;
            }
        }
    }
    &-scrollbar{
        height: 100%;
        overflow-x: hidden !important;
    }
}
</style>